import { Stack, TextField, Typography } from "@mui/material";
import { useAppDispatch } from "../../../../Redux/hooks";
import { updateResponse } from "../../../../Redux/reducers/providerConsentSlice";
import DateField from "./DateField";
import { useTranslation } from "react-i18next";
import { resolveInputPlaceholder } from "../../../EConsent/Builder/consentPlaceholders";

type Props = {
  currentBlock: any;
};

const InitialsField = ({ currentBlock }: Props) => {
  const { t } = useTranslation("econsent");
  const dispatch = useAppDispatch();
  const label = currentBlock?.label;
  const config = currentBlock?.config;
  const position = config?.position;

  const response = currentBlock?.response;
  const inputPlaceholder = resolveInputPlaceholder(
    currentBlock,
    t("BUILDER_UI.PREVIEW_ENTER_VALUE")
  );
  const datePlaceholder = resolveInputPlaceholder(
    currentBlock,
    t("BUILDER_UI.PREVIEW_SELECT_DATE")
  );

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (currentBlock.editable)
      dispatch(
        updateResponse({
          blockId: currentBlock.id,
          key: "input",
          value: event.target.value,
        })
      );
  };

  return (
    <Stack gap={1} direction={position === "top" ? "column-reverse" : "column"}>
      <Typography variant="subtitle1" fontWeight="medium">
        {label}
      </Typography>
      {config?.type === "date" ? (
        <DateField
          dateFormat={config?.format}
          blockId={currentBlock.id}
          value={response?.input || ""}
          editable={currentBlock.editable}
          placeholder={datePlaceholder}
        />
      ) : (
        <TextField
          sx={{
            width: {
              md: 350,
              xs: "100%",
            },
            maxWidth: "100%",
          }}
          placeholder={inputPlaceholder}
          value={response?.input || ""}
          multiline={config?.allowMultiline}
          rows={config?.allowMultiline ? 2 : 1}
          onChange={handleChange}
        />
      )}
    </Stack>
  );
};
export default InitialsField;
